module.exports = __webpack_public_path__ + "img/clsj.0c6f60c2.png";